import ScanLocationCard from "./scanLocationCard.container";
export default ScanLocationCard